import React, { useState } from 'react';
import FormView, { Option, Tag, FormViewProps } from './formView';

type Props = {
  type: string;
  presidentAgeOptions: Array<Option>;
  birthOnOptions: Array<Option>;
  businessTypeOptions: Array<Option>;
  fundraisingSimulationTags: Array<Tag>;
  ecf: FormViewProps;
  plus: FormViewProps;
};

const PageView = (props: Props) => {
  const [openAccordion, setOpenAccordion] = useState<'form1' | 'form2' | null>(
    null,
  );

  const toggleAccordion = (formId: 'form1' | 'form2' | null) => {
    setOpenAccordion(formId);
  };

  return (
    <div className="simulator__area">
      <FormView
        {...props.ecf}
        presidentAgeOptions={props.presidentAgeOptions}
        birthOnOptions={props.birthOnOptions}
        businessTypeOptions={props.businessTypeOptions}
        fundraisingSimulationTags={props.fundraisingSimulationTags}
        type="ecf"
        tagSortKey="ecf_order"
        onToggleAccordion={() => toggleAccordion('form1')}
        onCloseAccordion={() => toggleAccordion(null)}
        isOpen={openAccordion === 'form1'}
      />

      <FormView
        {...props.plus}
        presidentAgeOptions={props.presidentAgeOptions}
        birthOnOptions={props.birthOnOptions}
        businessTypeOptions={props.businessTypeOptions}
        fundraisingSimulationTags={props.fundraisingSimulationTags}
        type="plus"
        tagSortKey="plus_order"
        onToggleAccordion={() => toggleAccordion('form2')}
        onCloseAccordion={() => toggleAccordion(null)}
        isOpen={openAccordion === 'form2'}
      />
    </div>
  );
};

const renderPageView = (props: Props) => {
  return <PageView {...props} />;
};

export default renderPageView;
